<template>
  <div class="ai-chat-container">
    <div class="chat-container" ref="scrollContainer">
      <div v-for="(item, index) in messageList" :key="index">
        <div class="chat-messages">
          <!-- 纯文本 -->
          <div
            v-if="item.type === 'text'"
            class="message"
            :class="item.isMe ? 'user-message' : 'ai-message'"
          >
            <img src="@/assets/images/robot-avatar2.png" class="avatar" />
            <div class="message-content">
              <div class="sender">
                {{ item.isMe ? "我" : "AI助手" }}
              </div>
              <div class="text" v-html="item.markdownContent"></div>
            </div>
          </div>
        </div>
        <!-- AI助手快捷选项 -->
        <div v-if="item.type === '1'" class="message ai-message">
          <img
            src="@/assets/images/robot-avatar2.png"
            alt="AI助手头像"
            class="avatar"
          />
          <div class="message-content">
            <div class="sender">AI助手</div>
            <div
              style="
                background-color: #ffffff;
                padding: 10px;
                border-radius: 3px;
              "
            >
              <div class="sender" style="margin-bottom: 10px">
                <span class="ai-tag">AI</span> 您可以对我说
              </div>
              <div class="quick-options">
                <div
                  v-for="item in others"
                  :key="item.text"
                  class="option-btn flex-start"
                  @click="handleOptionClick(item)"
                >
                  <img :src="item.icon" class="option-icon" />
                  <span class="option-text">{{ item.text }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 选项消息 -->
        <div v-if="item.type === 'options'" class="options-box">
          <div class="" style="display: flex">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747032457200.svg"
              mode=""
              style="width: 15px; height: 15px"
            />
            <p style="margin-left: 5px; font-size: 14px; line-height: 14px">
              生成完成
            </p>
          </div>
          <!-- 主操作按钮 -->
          <button
            class="option-btn1 primary"
            style="
              background: #1877ff;
              color: white;
              margin-bottom: 12px;
              border-radius: 4px;
              margin-top: 15px;
              padding: 10px 0;
              text-align: center;
            "
            @click="creatClick(index)"
          >
            <!-- {{ distinguishType === 1 ? "创建问卷" : "创建考试" }} -->
            创建问卷
          </button>
          <!-- 次要操作按钮 -->
          <button
            class="option-btn1 secondary"
            style="
              background: white;
              color: #1877ff;

              border-radius: 4px;
            "
            @click="changeClick()"
          >
            提出修改意见
          </button>
        </div>

        <div v-if="item.type === 'presetsEntrance'" class="message ai-message">
          <img
            src="@/assets/images/robot-avatar2.png"
            alt="AI助手头像"
            class="avatar"
          />
          <div class="message-content">
            <div class="sender">AI助手</div>
            <div
              style="
                background-color: #ffffff;
                padding: 10px;
                border-radius: 3px;
              "
            >
              <div class="sender" style="margin-bottom: 10px">
                <span class="ai-tag">AI</span> 您可以对我说
              </div>
              <div class="presets-options">
                <div v-for="item in item.presets" :key="item.text">
                  <span @click="handleSpanClick(item)">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="item.type === 'success'" class="options-box">
          <div class="" style="display: flex">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747032457200.svg"
              mode=""
              style="width: 15px; height: 15px"
            />
            <p style="margin-left: 5px; font-size: 14px; line-height: 14px">
              问卷生成成功
            </p>
          </div>
          <button
            class="option-btn1 primary"
            style="
              background: #1877ff;
              color: white;
              margin-bottom: 12px;
              border-radius: 4px;
              margin-top: 15px;
              padding: 10px 0;
              text-align: center;
            "
            @click="lookClick(item.content)"
          >
            立即查看
          </button>
        </div>

        <div class="chat-messages">
          <!-- 纯文本 -->
          <div
            v-if="item.type === 'upload'"
            class="message"
            :class="item.isMe ? 'user-message' : 'ai-message'"
          >
            <img src="@/assets/images/robot-avatar2.png" class="avatar" />
            <div class="message-content">
              <div class="sender">
                {{ item.isMe ? "我" : "AI助手" }}
              </div>
              <div class="upload-wapper">
                <img
                  :src="
                    item.fileType == 'pdf'
                      ? 'https://ossfastmake.mustke.com/wenjuan/tupian/PPT-1767511748115.svg'
                      : item.fileType == 'excel'
                      ? 'https://ossfastmake.mustke.com/wenjuan/tupian/excel-1776242869593.svg'
                      : 'https://ossfastmake.mustke.com/wenjuan/tupian/PPT 2-1767511882499.svg'
                  "
                  alt=""
                />
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <p class="file-name">{{ item.fileName }}</p>
                  <p class="file-size">大小：{{ item.fileSize }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <div
        style="
          border: 1px solid #dcdde0;
          border-radius: 2px;
          background-color: #ffffff;
          width: 100%;
          padding: 10px;
          box-sizing: border-box;
        "
      >
        <textarea
          v-model="inputMessage"
          placeholder="请输入内容"
          rows="8"
          style="resize: none; width: 100%"
        ></textarea>
        <div class="flex-between">
          <div class="upload-file" @click="handleUploadClick">
            <img
              src="@/assets/images/ai/ai_upload.svg"
              alt="上传图标"
              class="upload-icon"
            />
            上传文件
          </div>
          <button class="send-btn" @click="sendMessage">发送</button>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept=".xls,.xlsx,.doc,.docx,.pdf"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
// import marked from "marked";
import { AICreateNew } from "@/api/index.js";
import showdown from "showdown";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "AIChatPage",
  data() {
    return {
      // 可根据实际需求添加数据
      others: [
        {
          icon: require("@/assets/images/ai/ai03.svg"),
          text: "问卷",
        },
        {
          icon: require("@/assets/images/ai/ai01.svg"),
          text: "投票",
        },
        {
          icon: require("@/assets/images/ai/ai02.svg"),
          text: "接龙",
        },
        {
          icon: require("@/assets/images/ai/ai04.svg"),
          text: "二维码",
        },
        {
          icon: require("@/assets/images/ai/ai05.svg"),
          text: "考试",
        },
        {
          icon: require("@/assets/images/ai/ai06.svg"),
          text: "名片",
        },
        {
          icon: require("@/assets/images/ai/ai07.svg"),
          text: "文件上传",
        },
        {
          icon: require("@/assets/images/ai/ai08.svg"),
          text: "测评",
        },
      ],
      messageList: [
        {
          type: "text",
          content:
            "你好，我是AI智能助手，您可以输入文字告诉我您对问卷调研、社会调查、信息收集、评分活动的需求，或者试着点击下面的示例，我会为您生成合适的内容。",
          markdownContent:
            "你好，我是AI智能助手，您可以输入文字告诉我您对问卷调研、社会调查、信息收集、评分活动的需求，或者试着点击下面的示例，我会为您生成合适的内容。",
          isMe: false,
          avatar: "/static/robot-avatar2.png",
          nickname: "AI助手",
        },
        {
          sender: "ai",
          content: "好的，我会为您创建一个问卷。",
          markdownContent: "好的，我会为您创建一个问卷。",
          type: "1", // 自定义1
          name: "AI助手",
        },
        {
          sender: "user",
          content: "问卷创建",
          markdownContent: "问卷创建",
          type: "0", // 文本消息
          name: "我",
        },
      ],
      optionsOne: [
        "生成一个大学生食堂满意度的调查问卷",
        "生成一个聚餐吃什么投票问卷",
        "生成一个素食吃什么投票问卷",
        "生成一个旅游目的地选择调研",
      ],
      optionsTwo: [
        "生成一个大学测试考试",
        "生成一个高中测试考试",
        "生成一个初中测试考试",
      ],
      inputMessage: "",
      isStreaming: false,
      tempMessageIndex: -1,
      bufferMessage: "",
      loading: null,
      uuid: "",
    };
  },
  mounted() {
    // 1. 先监听事件（原有语法不变！）
    this.$websocket.vueInstance.$on("websocket:open", this.handleOpen);
    this.$websocket.vueInstance.$on("websocket:message", this.handleMessage);
    this.$websocket.vueInstance.$on("websocket:close", this.handleClose);
    this.$websocket.vueInstance.$on("websocket:error", this.handleError);

    // 2. 后连接 WebSocket（确保监听已注册）
    // this.$websocket.connect("ws://39.104.70.61:8888/ai/stream");
    this.$websocket.connect("wss://wenjuantestsocket.kuaikaoshi.top/ai/stream");
  },
  beforeDestroy() {
    // 重要：组件销毁时移除监听，避免内存泄漏
    this.$websocket.vueInstance.$off("websocket:open", this.handleOpen);
    this.$websocket.vueInstance.$off("websocket:message", this.handleMessage);
    this.$websocket.vueInstance.$off("websocket:close", this.handleClose);
    this.$websocket.vueInstance.$off("websocket:error", this.handleError);

    // 关闭连接
    this.$websocket.close();
  },
  methods: {
    handleOpen() {
      console.log("连接成功！");
      this.isConnected = true;
    },
    handleMessage(event) {
      console.log("收到消息：", event);

      const chunk = event.data;
      this.bufferMessage += chunk;

      // 检查消息是否结束
      if (chunk.includes("[DONE]")) {
        const finalContent = this.bufferMessage.replace("[DONE]", "");
        // // this.bufferMessage = '';
        // if (finalContent.includes("问卷")) {
        //   this.distinguishType = 1;
        // } else if (finalContent.includes("考试")) {
        //   this.distinguishType = 2;
        // }
        this.updateMessage(finalContent, true);
        this.bufferMessage = "";
        this.isStreaming = false;
        // this.inputDisabled = false;
      } else {
        // 如果是新消息流
        if (!this.isStreaming) {
          this.messageList.push({
            type: "text",
            content: "",
            isMe: false,
            avatar: "/static/robot-avatar2.png",
            nickname: "AI助手",
            time: Date.now(),
          });
          this.tempMessageIndex = this.messageList.length - 1;
          this.isStreaming = true;
        }
        this.updateMessage(chunk, false);

        console.log("2222222");
      }
    },
    handleClose(event) {
      console.log("连接关闭：", event.code);
      this.isConnected = false;
    },
    handleError(error) {
      console.error("连接错误：", error);
      this.isConnected = false;
    },
    sendMessage() {
      if (this.inputMessage === "问卷") {
        this.messageList.push({
          type: "text",
          content: this.inputMessage,
          markdownContent: this.inputMessage,
          isMe: true,
          avatar: "/static/robot-avatar2.png",
          nickname: "我",
          time: Date.now(),
        });
        this.messageList.push({
          type: "presetsEntrance",
          content: "",
          isMe: false,
          avatar: "/static/robot-avatar2.png",
          nickname: "AI助手",
          presets: this.optionsOne,
        });
        this.inputMessage = "";
        this.scrollToBottom();
        return;
      }
      this.$websocket.send(this.inputMessage);
      this.messageList.push({
        type: "text",
        content: this.inputMessage,
        markdownContent: this.inputMessage,
        isMe: true,
        avatar: "/static/robot-avatar2.png",
        nickname: "我",
        time: Date.now(),
      });
      this.inputMessage = "";
      this.isStreaming = false;
      this.bufferMessage = "";
      this.scrollToBottom();
    },

    // 新增更新消息方法
    updateMessage(content, isFinal) {
      const converter = new showdown.Converter({
        simpleLineBreaks: true,
      });
      if (this.tempMessageIndex >= 0) {
        const message = this.messageList[this.tempMessageIndex];
        message.content += content;
        message.markdownContent = converter.makeHtml(message.content);

        if (isFinal) {
          const message = this.messageList[this.tempMessageIndex];
          message.content += content;
          message.markdownContent = converter.makeHtml(content);
          message.content = content;
          message.time = Date.now(); // 更新最终时间

          // 如果包含选项
          if (message.content.includes("是否需要调整")) {
            this.messageList.push({
              type: "options",
              content: "",
              options: ["修改问题", "创建问卷"],
              isMe: false,
              avatar: "/static/robot-avatar2.png",
              nickname: "AI助手",
              time: Date.now(),
            });
          }
        } else {
        }
        console.log(message.markdownContent, "markdownContent");
        this.$set(this.messageList, this.tempMessageIndex, message);
        this.scrollToBottom();
      }
    },
    scrollToBottom() {
      // $nextTick：确保 DOM 已更新（列表渲染完成）
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container) {
          // 关键：scrollTop = scrollHeight（滚动高度 = 内容总高度）
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    handleUploadClick() {
      this.$refs.fileInput.click();
      // this.$confirm("功能升级中...", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // });
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        this.$message.error("请选择文件");
        return;
      }
      // if (!/^\.(xls|xlsx|doc|docx|pdf)$/.test(file.name)) {
      //   this.$message.error("请上传 Excel、Word 或 PDF 文件");
      //   return;
      // }
      const fileName = file.name || "";
      const fileExt = fileName.split(".").pop().toLowerCase();
      let fileSize = (file.size / (1024 * 1024)).toFixed(2);
      fileSize =
        fileSize === "0.00"
          ? (file.size / 1024).toFixed(2) + "KB"
          : fileSize + "MB";

      let fileType = "file";
      if (fileExt === "pdf") fileType = "pdf";
      if (fileExt === "doc" || fileExt === "docx") fileType = "word";
      if (fileExt === "xls" || fileExt === "xlsx") fileType = "excel";

      this.messageList.push({
        type: "upload",
        isMe: true,
        avatar: this.avatarUrl || "/static/robot-avatar2.png",
        nickname: "我",
        time: Date.now(),
        fileName,
        fileType,
        fileExt,
        fileSize,
      });

      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("type", "ai");
      formData.append("uuid", "GuidePage");
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          console.log("上传成功的响应", response.data.urls);
          this.$websocket.send(response.data.urls);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    changeClick() {
      // this.inputMessage = this.distinguishType === 1 ? "修改问卷" : "修改考试";
      this.inputMessage = "修改问卷";
      this.sendMessage();
    },
    // 创建问卷 开始轮询
    async creatClick(index) {
      this.loading = this.$loading({
        lock: true,
        text: "创建中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let messageItem = this.messageList[index - 1];
      console.log(messageItem, "messageItem");

      let res = await AICreateNew({
        text: messageItem.content,
      });
      if (res.code == 200) {
        console.log(res, "resss");
        // this.distinguishType = Number(res.data.data.questionnaireType);
        this.uuid = res.data.uuid;
        this.loading.close();
        this.messageList.push({
          type: "success",
          content: res.msg,
          options: [],
          isMe: false,
          avatar: "/static/robot-avatar2.png",
          nickname: "AI助手",
          // time: this.getCurrentTime(),
        });
        this.scrollToBottom();
      } else {
        this.loading.close();
        this.$message({
          type: "error",
          message: "创建失败",
          offset: "150",
        });
      }
      this.scrollToBottom();
    },
    lookClick(msg) {
      console.log("跳转详情", msg);
      this.$router.push({
        path: "/create",
        query: {
          id: this.uuid,
        },
      });
    },
    handleOptionClick(item) {
      switch (item.text) {
        case "投票":
          window.open("https://www.tpguanjia.com");
          break;
        case "接龙":
          window.open("https://www.jielong.vip");
          break;
        case "问卷":
          this.inputMessage = item.text;
          this.sendMessage();
          break;
        case "二维码":
          this.$confirm("功能升级中...", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
          break;
        case "考试":
          // this.$confirm("功能升级中...", "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "warning",
          // });
          this.inputMessage = item.text;
          this.sendMessage();
          break;
        case "名片":
          window.open("https://www.99mingpian.cn");
          break;
        case "文件上传":
          this.handleUploadClick();
          break;
        case "测评":
          this.inputMessage = item.text;
          this.sendMessage();
          break;
        default:
          break;
      }
    },
    handleSpanClick(item) {
      this.inputMessage = item;
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.ai-chat-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 80px);
  background-color: #f6f6f6;
  border-radius: 6px;
}

.chat-container {
  width: 100%;
  flex: 1;
  overflow-y: auto;
}

/* 聊天消息区域 */
.chat-messages {
  flex: 1;
  padding: 10px;
  /* overflow-y: auto; */
}

.message {
  display: flex;
  margin-bottom: 10px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.message-content {
  max-width: 60%;
}

.sender {
  font-weight: bold;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}

.ai-tag {
  background-color: #663399;
  color: #fff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 6px;
}

.text {
  background-color: #fff;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  border: 1px solid #eaecef;
  /* white-space: pre-line; */
}

.upload-wapper {
  background-color: #fff;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  border: 1px solid #eaecef;
  /* white-space: pre-line; */
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    margin-right: 15px;
    width: 41px;
    height: 44px;
  }
}

.file-name {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}

.file-size {
  font-size: 12px;
  color: #a3a7ad;
  margin-top: 10px;
}

.quick-options {
  /* width: 112px; */
  display: grid;
  grid-template-columns: repeat(2, 80px);
  grid-gap: 10px;
}

.presets-options {
  width: 175px;
  padding: 8px 12px;

  span {
    display: block;
    width: 100%;
    height: 100%;
    text-align: left;
    cursor: pointer;
    background: #f8f9fd;
    font-size: 12px;
    padding: 4px;
    box-sizing: border-box;
    margin-top: 4px;
  }
}

.option-btn {
  width: 80px;
  height: 30px;
  background: #f8f9fd;
  border: 0.25px solid #e3e3e3;
  border-radius: 1.5px;
  text-align: center;
  cursor: pointer;
}

.option-icon {
  width: 16.6px;
  height: 16.6px;
  margin-right: 6px;
  margin-left: 6px;
}

.option-text {
  font-size: 10px;
  color: #333333;
  font-weight: bold;
}

.user-message {
  flex-direction: row-reverse;
  align-items: flex-start;
}

.user-message .message-content {
  text-align: right;
}

.user-message .text {
  background-color: #007fff;
  color: #fff;
  border: none;
}

.copy-btn {
  font-size: 12px;
  color: #666;
  cursor: pointer;
  margin-top: 4px;
}

/* 输入区域 */
.input-area {
  display: flex;
  align-items: center;
  padding: 7.5px;
  /* background-color: #fff;
  border-top: 1px solid #eaecef; */
}

.input-box {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #eaecef;
  border-radius: 4px;
  margin-right: 10px;
}

.upload-file {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.upload-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.send-btn {
  width: 80px;
  height: 40px;
  background-color: #007fff;
  color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
}

.options-box {
  box-shadow: 0 4rpx 12rpx rgba(0, 0, 0, 0.08);
  width: 320px;
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin: 12px auto;

  .option-btn1 {
    background: #f5f5f5;
    color: #333;
    font-size: 32rpx;
    padding: 16rpx 30rpx;
    font-weight: 500;
    border-radius: 8rpx;
    line-height: 1.5;
    transition: all 0.3s;
    margin: 0;
    width: 290px;

    &::after {
      border: none;
    }

    &:active {
      background: #e5e5e5;
      transform: scale(0.98);
    }
  }

  .options-time {
    display: block;
    font-size: 22rpx;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 15rpx;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AiCreate/index.vue